import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom"

const styles = css`
display: grid;
grid-template-columns: 50px auto;
font-size: 1.5em;
padding-bottom: 20px;
 & .back {
  align-self: flex-start;
  font-weight: bold;
 }
 & .title {
  align-self: flex-start;
 }
`
const Title = styled(({ className, title = '' }) => {
  const navigate = useNavigate();

  return (
    <div className={className}>
      <Link className='back' onClick={() => navigate(-1)}>
        <FontAwesomeIcon icon={faArrowLeftLong} />
      </Link>
      <div className='title'>
        {title}
      </div>
    </div>
  )
})`${styles}`;

export default Title;